<template>
    <div class="content-box" v-loading="localExprotLoading">
        <el-row class="row-col-style" :gutter="20">
            <el-col class="row-col-style" :span="6">
                <div class="left-top-box" ref="leftBox">
                    <el-card class="left-card-top">
                        <div class="cardTop">
                            <el-button @click="loadingDbcDialog">加载DBC</el-button>
                            <!--                            <el-button>导入报文</el-button>-->
                            <el-dropdown @command="openExprot">
                                <el-button>导入报文</el-button>
                                <el-dropdown-menu slot="dropdown">
                                    <el-dropdown-item command="a">本地导入</el-dropdown-item>
                                    <el-dropdown-item command="b">加载历史报文</el-dropdown-item>
                                </el-dropdown-menu>
                            </el-dropdown>
                            <el-button @click="convertAscFile">解析</el-button>
                        </div>
                        <div class="cardBottom">
                            <div class="cardTitle">
                                <span>信号列表</span>
                                <el-input size="mini" class="inputClass" v-model="input" placeholder="搜索信号"
                                          suffix-icon="el-icon-search" @change="inputChange"></el-input>
                            </div>
                            <div class="infoBox" style="margin-top: 10px">
                                <el-tabs v-model="tabsActiveName">
                                    <el-tab-pane label="图一" name="first">
                                        <div :class="this.treeData.length>0?'active':''" :style="`height: ${scrollbarHeight}px;`">
                                            <el-collapse v-model="activeName">
                                                <el-collapse-item v-for="(item,index) in treeData" :key="index"
                                                                  :title="item.key"
                                                                  :name="index.toString()">
                                                    <el-checkbox-group style="display: flex;flex-direction: column"
                                                                       v-model="checkbox" size="small"
                                                                       :max="maxCheck">
                                                        <el-checkbox style="width: 45%"
                                                                     @change="checked=>change(checked,item.key,son,sindex)"
                                                                     :label="son.key"
                                                                     v-for="(son,sindex) in item.children"
                                                                     :key="sindex"></el-checkbox>
                                                    </el-checkbox-group>
                                                </el-collapse-item>
                                            </el-collapse>
                                        </div>
                                    </el-tab-pane>
                                    <el-tab-pane label="图二" name="second">
                                        <div :class="this.treeData.length>0?'active':''"  :style="`height: ${scrollbarHeight}px;`">
                                            <el-collapse v-model="activeName2" accordion>
                                                <el-collapse-item v-for="(item,cindex) in treeData"
                                                                  :title="item.key"
                                                                  :key="cindex"
                                                                  :name="cindex.toString()">
                                                    <el-checkbox-group style="display: flex;flex-direction: column"
                                                                       v-model="checkbox2" size="small"
                                                                       :max="maxCheck">
                                                        <el-checkbox style="width: 45%"
                                                                     @change="checked=>change2(checked,item.key,son,sindex)"
                                                                     :label="son.key"
                                                                     v-for="(son,sindex) in item.children"
                                                                     :key="sindex"></el-checkbox>
                                                    </el-checkbox-group>
                                                </el-collapse-item>
                                            </el-collapse>
                                        </div>
                                    </el-tab-pane>
                                </el-tabs>
                            </div>
                        </div>
                    </el-card>
                </div>
                <!--                <div class="left-bottom-box" ref="scrollbarRef">-->
                <!--                    <el-card class="left-card-bottom">-->
                <!--                        <div class="padding-box" ref="paddingBox1">-->
                <!--                            <div class="journal-box">-->
                <!--                                <span>操作日志</span>-->
                <!--                                <el-tooltip class="item" effect="dark" content="最大化" placement="bottom">-->
                <!--                                    <i @click="screen(1)" class="el-icon-full-screen"></i>-->
                <!--                                </el-tooltip>-->
                <!--                            </div>-->
                <!--                            <el-scrollbar :style="!isScreen?`height: ${scrollbarHeight}px`:'height:100%'"-->
                <!--                                          wrap-style="overflow-x:hidden;">-->
                <!--                                <el-timeline style="padding-left: 34%">-->
                <!--                                    <el-timeline-item-->
                <!--                                            v-for="(activity, index) in activities"-->
                <!--                                            :key="index"-->
                <!--                                            :timestamp="activity.operateTime">-->
                <!--                                        {{ activity.operateLog }}-->
                <!--                                    </el-timeline-item>-->
                <!--                                </el-timeline>-->
                <!--                            </el-scrollbar>-->
                <!--                        </div>-->
                <!--                    </el-card>-->
                <!--                </div>-->
            </el-col>
            <!--      <div class="featerBox" ref="paddingBox2">-->
            <el-col :span="18" class="elcol18">
                <div style="background: #ffffff;padding: 20px;box-sizing: border-box;height: 100%" ref="paddingBox2">
                    <div style="display: flex;justify-content: space-between">
                        <el-form :inline="true" ref="form" :model="form" label-width="80px">
                            <el-form-item label="选择图表">
                                <el-select @change="echartsChange" v-model="form.region" placeholder="请选择图表"
                                           :popper-append-to-body='false' popper-class='select-popper'>
                                    <el-option label="单图" value="0"></el-option>
                                    <el-option label="多图" value="1"></el-option>
                                </el-select>
                            </el-form-item>
                            <!--                            <el-form-item>-->
                            <!--                                <el-button type="primary" @click="onSubmit">确定</el-button>-->
                            <!--                            </el-form-item>-->
                        </el-form>
                        <el-tooltip class="item" effect="dark" content="最大化" placement="bottom">
                            <i @click="screen(2)" class="el-icon-full-screen"></i>
                        </el-tooltip>
                    </div>
                    <div v-loading="loading" style="width: 100%;height: 97%;display: flex;flex-direction: column">
                        <div id="myEcharts1" ref="myEcharts1" style="width: 100%;height: 97%;flex: 1"/>
                        <div id="myEcharts2" ref="myEcharts2"
                             style="width: 100%;height: 97%;flex: 1"/>
                    </div>
                </div>

            </el-col>
            <!--        </div>-->
        </el-row>
        <el-dialog :destroy-on-close="true" top="25" class="myDbcDialog" title="加载DBC" width="60%"
                   :visible.sync="dialogTableVisible"
                   :close-on-click-modal="false">
            <DBCAdministration @loadingDbc="getLoadDbcData"></DBCAdministration>
        </el-dialog>
        <el-dialog title="本地导入" :visible.sync="dialogFormVisible" width="30%">
            <el-form :model="exprotForm" :rules="exprotRules" label-position="top">
                <el-form-item label="上传文件" prop="file">
                    <el-upload
                            ref="fileUpload"
                            action="##"
                            :on-change="onchange"
                            :http-request="localExprot"
                            :on-remove="handleRemove"
                            :file-list="fileList"
                            accept=".asc,.blf">
                        <el-button slot="trigger" type="primary" size="small">选择文件</el-button>
                        <!--                        <span slot="tip" style="margin-left: 20px">只能上传doc/docx/xls/xlsx/ppt/pptx/pdf文件</span>-->
                    </el-upload>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogFormVisible = false">取 消</el-button>
                <el-button type="primary" @click="submitLocalExprot">确 定</el-button>
            </div>
        </el-dialog>
        <el-dialog title="加载历史报文" :visible.sync="dialogFormVisible2" width="30%" :close-on-click-modal="false">
            <el-form :model="exprotForm2" :rules="exprotRules2" ref="exprotForm2" label-position="left">
                <el-form-item label="选择VIN" prop="vin">
                    <el-select style="width: 320px" size="mini" v-model="exprotForm2.vin" placeholder="请选择">
                        <el-option
                                v-for="(item,index) in options"
                                :key="index"
                                :label="item.vin"
                                :value="item.vin">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="选择时间" prop="date">
                    <el-date-picker
                            style="width: 320px"
                            value-format="yyyy-MM-dd HH:mm:ss"
                            @change="timeChange"
                            size="mini"
                            v-model="exprotForm2.date"
                            type="datetimerange"
                            range-separator="至"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期">
                    </el-date-picker>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="closeDialogFormVisible">取 消</el-button>
                <el-button :loading="btnLoading" type="primary" @click="submitLoadForm('exprotForm2')">{{ btnLoading ?
                    '加载中 ...' : '确 定' }}
                </el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import * as ec from 'echarts';
    import {getDbcList} from "../../common/dbc";
    import DBCAdministration from "../dataManagement/DBCAdministration";
    import {getOperatelogList} from "../../common/journal";
    import {convertAscFile, getVinList, convertAscFileFromDb, convertDbc, checkDbc} from "../../common/playBackData";
    import ScreenFull from 'screenfull/dist/screenfull'

    export default {
        name: "playbackData",
        components: {
            DBCAdministration
        },
        data() {
            return {
                convertAscMap: {},
                isCanMAP: false,
                treeData: [],
                treeData2: [],
                defaultProps: {
                    children: 'children',
                    label: 'key'
                },
                tabsActiveName: 'first',
                activeName: [],
                activeName2: [],
                colorArr: [],
                isScreen: false,
                btnLoading: false,
                options: [],
                localExprotLoading: false,
                fileList: [],
                localExprotFile: null,
                exprotForm: {
                    file: ''
                },
                exprotForm2: {
                    vin: '',
                    date: '',
                    startTime: '',
                    endTime: ''
                },
                exprotRules: {
                    file: [
                        {
                            required: true,
                            message: '请至少选择一个产品标签',
                            trigger: 'change'
                        }
                    ]
                },
                exprotRules2: {
                    vin: [
                        {required: true, message: '请选择vin', trigger: 'change'}
                    ],
                    date: [
                        {type: 'array', required: true, message: '请选择时间', trigger: 'blur'}
                    ],
                },
                dialogFormVisible: false,
                dialogFormVisible2: false,
                currentPage: 1,
                pageSize: 100,
                tableHeight: 0,
                dialogTableVisible: false, // dbc弹框
                gridData: [], //DBC列表
                isPlay: false,
                loading: false,
                echartsinstance: null,
                echartsinstance2: null,
                form: {
                    region: '0'
                },
                echarts: 1,
                isShow: true,
                input: '',
                scrollbarHeight: 0,
                signal: [],
                signal2: [],
                checkbox: [],
                checkbox2: [],
                activities: [],
                t: null,
                length: 0,
                uploadedDataURL: '',
                mySetTimeout: null,
                maxCheck: 1,
                option: {
                    backgroundColor: '#FFF',
                    grid: {
                        top: '9%',
                        bottom: '19%',
                        left: '6%',
                        right: '4%'
                    },
                    tooltip: {
                        trigger: 'axis',
                        label: {
                            show: true
                        }
                    },
                    legend: {
                        right: 20,
                        orient: 'horizontal',
                        data: []
                    },
                    dataZoom: [{
                        type: 'inside',
                        start: 0,
                        end: 2
                    }, {
                        start: 0,
                        end: 10,
                        handleIcon: 'M10.7,11.9v-1.3H9.3v1.3c-4.9,0.3-8.8,4.4-8.8,9.4c0,5,3.9,9.1,8.8,9.4v1.3h1.3v-1.3c4.9-0.3,8.8-4.4,8.8-9.4C19.5,16.3,15.6,12.2,10.7,11.9z M13.3,24.4H6.7V23h6.6V24.4z M13.3,19.6H6.7v-1.4h6.6V19.6z',
                        handleSize: '80%',
                        handleStyle: {
                            color: '#fff',
                            shadowBlur: 3,
                            shadowColor: 'rgba(0, 0, 0, 0.6)',
                            shadowOffsetX: 2,
                            shadowOffsetY: 2
                        }
                    }],
                    xAxis: {},
                    yAxis: {},
                    series: []
                },
                option2: {
                    backgroundColor: '#FFF',
                    grid: {
                        top: '9%',
                        bottom: '19%',
                        left: '6%',
                        right: '4%'
                    },
                    tooltip: {
                        trigger: 'axis',
                        label: {
                            show: true
                        }
                    },
                    legend: {
                        right: 20,
                        orient: 'horizontal',
                        data: []
                    },
                    dataZoom: [{
                        type: 'inside',
                        start: 0,
                        end: 2
                    }, {
                        start: 0,
                        end: 10,
                        handleIcon: 'M10.7,11.9v-1.3H9.3v1.3c-4.9,0.3-8.8,4.4-8.8,9.4c0,5,3.9,9.1,8.8,9.4v1.3h1.3v-1.3c4.9-0.3,8.8-4.4,8.8-9.4C19.5,16.3,15.6,12.2,10.7,11.9z M13.3,24.4H6.7V23h6.6V24.4z M13.3,19.6H6.7v-1.4h6.6V19.6z',
                        handleSize: '80%',
                        handleStyle: {
                            color: '#fff',
                            shadowBlur: 3,
                            shadowColor: 'rgba(0, 0, 0, 0.6)',
                            shadowOffsetX: 2,
                            shadowOffsetY: 2
                        }
                    }],
                    xAxis: {},
                    yAxis: {},
                    series: []
                },
                allArr: [],
                newArr: [],
                interval: null
            }
        },
        watch: {
            option(val1, val2) {
                console.log(val1, val2)
            },
            input(val1) {
                // this.$refs.tree.filter(val1);
                // console.log(val1)
                if (val1 === '') {
                    this.treeData = this.treeData2
                    this.activeName = []
                    this.activeName2 = []
                } else {
                    for (let argumentsKey in this.treeData) {
                        // console.log(this.treeData[argumentsKey].children)
                        this.treeData = this.treeData.filter(children => {
                            // console.log(children)
                            return children.key.includes(val1)
                        })
                    }
                }
            }
        },
        destroyed() {
            clearInterval(this.interval)
        },
        created() {
            let that = this
            window.onresize = function () {
                if (!that.checkFull()) {
                    // 退出全屏后要执行的动作
                    that.isScreen = false
                }
            }
        },
        mounted() {
            this.getVinList()
            this.getOperatelogList()
            this.interval = setInterval(() => {
                this.getOperatelogList()
            }, 5000)
            this.$nextTick(function () {
                this.scrollbarHeight = this.$refs.leftBox.offsetHeight - 201
                console.log(this.$refs.leftBox.offsetHeight)
                console.log(this.scrollbarHeight)
            })

            let option = {
                title: {
                    text: `图1`,
                    left: 'left'
                },
                backgroundColor: '#FFF',
                grid: {
                    top: '9%',
                    bottom: '19%',
                    left: '6%',
                    right: '4%'
                },
                tooltip: {
                    trigger: 'axis',
                    label: {
                        show: true
                    }
                },
                legend: {
                    right: 20,
                    orient: 'horizontal',
                    data: []
                },
                dataZoom: [{
                    type: 'inside',
                    start: 0,
                    end: 2
                }, {
                    start: 0,
                    end: 10,
                    handleIcon: 'M10.7,11.9v-1.3H9.3v1.3c-4.9,0.3-8.8,4.4-8.8,9.4c0,5,3.9,9.1,8.8,9.4v1.3h1.3v-1.3c4.9-0.3,8.8-4.4,8.8-9.4C19.5,16.3,15.6,12.2,10.7,11.9z M13.3,24.4H6.7V23h6.6V24.4z M13.3,19.6H6.7v-1.4h6.6V19.6z',
                    handleSize: '80%',
                    handleStyle: {
                        color: '#fff',
                        shadowBlur: 3,
                        shadowColor: 'rgba(0, 0, 0, 0.6)',
                        shadowOffsetX: 2,
                        shadowOffsetY: 2
                    }
                }],
                xAxis: {},
                yAxis: {},
                series: [
                    {
                        name: '',
                        data: [],
                        type: 'line'
                    },
                ]
            }
            let a = document.getElementById('myEcharts1')
            this.echartsinstance = ec.init(a)
            this.echartsinstance.setOption(option);
            //
            let option2 = {
                title: {
                    text: `图2`,
                    left: 'left'
                },
                backgroundColor: '#FFF',
                grid: {
                    top: '9%',
                    bottom: '19%',
                    left: '6%',
                    right: '4%'
                },
                tooltip: {
                    trigger: 'axis',
                    label: {
                        show: true
                    }
                },
                legend: {
                    right: 20,
                    orient: 'horizontal',
                    data: []
                },
                dataZoom: [{
                    type: 'inside',
                    start: 0,
                    end: 2
                }, {
                    start: 0,
                    end: 10,
                    handleIcon: 'M10.7,11.9v-1.3H9.3v1.3c-4.9,0.3-8.8,4.4-8.8,9.4c0,5,3.9,9.1,8.8,9.4v1.3h1.3v-1.3c4.9-0.3,8.8-4.4,8.8-9.4C19.5,16.3,15.6,12.2,10.7,11.9z M13.3,24.4H6.7V23h6.6V24.4z M13.3,19.6H6.7v-1.4h6.6V19.6z',
                    handleSize: '80%',
                    handleStyle: {
                        color: '#fff',
                        shadowBlur: 3,
                        shadowColor: 'rgba(0, 0, 0, 0.6)',
                        shadowOffsetX: 2,
                        shadowOffsetY: 2
                    }
                }],
                xAxis: {},
                yAxis: {},
                series: [
                    {
                        name: '',
                        data: [],
                        type: 'line'
                    },
                ]
            }
            let b = document.getElementById('myEcharts2')
            this.echartsinstance2 = ec.init(b)
            this.echartsinstance2.setOption(option2);

            window.addEventListener("resize", () => {
                if (this.echartsinstance) {
                    this.echartsinstance.resize();
                    this.echartsinstance2.resize();
                }
            });
            // console.log(this.option)
            // console.log(this.getRandomColor())
        },
        methods: {
            filterNode(value, data) {
                console.log(value, data)
                if (!value) return true;
                return data.key.indexOf(value) !== -1;
            },
            getRandomColor() {
                return '#' + Math.floor(Math.random() * 16777215).toString(16);
            },
            checkFull() {
                //判断浏览器是否处于全屏状态 （需要考虑兼容问题）
                //火狐浏览器
                var isFull =
                    document.mozFullScreen ||
                    document.fullScreen ||
                    //谷歌浏览器及Webkit内核浏览器
                    document.webkitIsFullScreen ||
                    document.webkitRequestFullScreen ||
                    document.mozRequestFullScreen ||
                    document.msFullscreenEnabled
                if (isFull === undefined) {
                    isFull = false
                }
                return isFull
            },
            getVinList() {
                getVinList({}).then(res => {
                    console.log(res)
                    this.options = res.data
                }).catch(err => {
                    console.log(err)
                })
            },
            inputChange(e) {
                console.log(e)
            },
            closeDialogFormVisible() {
                this.exprotForm2 = {
                    vin: '',
                    date: '',
                    startTime: '',
                    endTime: ''
                },
                    this.btnLoading = false
                this.dialogFormVisible2 = false
            },
            // 加载历史报文
            submitLoadForm(formName) {
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        this.btnLoading = true
                        convertAscFileFromDb(this.exprotForm2).then(res => {
                            console.log(res)
                            if (res.code === 200) {
                                this.$notify.success({
                                    title: '成功提示',
                                    message: '历史报文加载成功'
                                })
                                // let obj = res.data.canMap; //定义对象（data为获取到的对象，在这里定义）
                                // // console.log(obj)
                                // // this.signal = obj
                                // this.signal = Object.keys(obj).map(val => ({
                                //     key: val,
                                //     val: obj[val]
                                // }))
                                // this.signal2 = Object.keys(obj).map(val => ({
                                //     key: val,
                                //     val: obj[val]
                                // }))
                                this.convertAscMap = res.data.canMap
                                this.isCanMAP = true
                                for (let i = 0; i < this.signal2.length; i++) {
                                    this.colorArr.push(this.getRandomColor())
                                }
                                this.btnLoading = false
                                this.dialogFormVisible2 = false
                            } else {
                                this.$notify.error({
                                    title: '错误提示',
                                    message: '该vin在所选时间段暂无报文'
                                })
                                this.isCanMAP = false
                                this.btnLoading = false
                                this.dialogFormVisible2 = false
                            }
                        }).catch(err => {
                            console.log(err)
                        })
                    } else {
                        console.log('error submit!!');
                        return false;
                    }
                });
            },
            // 时间选择
            timeChange(e) {
                console.log(e)
                this.exprotForm2.startTime = e[0];
                this.exprotForm2.endTime = e[1];
            },
            // 解析
            convertAscFile() {
                console.log(this.treeData)
                if (this.treeData.length === 0) {
                    this.$notify.error({
                        title: '错误提示',
                        message: '请加载DBC'
                    })
                    return false
                }
                if (!this.localExprotFile) {
                    this.$notify.error({
                        title: '错误提示',
                        message: '请导入报文'
                    })
                    return false
                }
                checkDbc().then(res => {
                    console.log(res)
                    if (res.code === 200) {
                        this.localExprotLoading = true
                        convertAscFile(this.localExprotFile).then(res => {
                            console.log(res)
                            if (res.code === 200) {
                                this.convertAscMap = res.data.canMap
                                this.isCanMAP = true
                                // let obj = res.data.canMap; //定义对象（data为获取到的对象，在这里定义）
                                // this.signal = Object.keys(obj).map(val => ({
                                //     key: val,
                                //     val: obj[val]
                                // }))
                                // this.signal2 = Object.keys(obj).map(val => ({
                                //     key: val,
                                //     val: obj[val]
                                // }))
                                // for (let i = 0; i < this.signal2.length; i++) {
                                //     this.colorArr.push(this.getRandomColor())
                                // }
                                // console.log(this.signal);
                                this.localExprotLoading = false
                                this.$notify.success({
                                    title: '成功提示',
                                    message: '本地导入解析成功'
                                })
                            } else {
                                this.isCanMAP = false
                                this.$notify.error({
                                    title: '错误提示',
                                    message: '解析失败'
                                })
                            }
                        }).catch(err => {
                            console.log(err)
                        })
                    } else {
                        this.$notify.error({
                            title: '错误提示',
                            message: '请先加载DBC'
                        })
                    }
                }).catch(err => {
                    console.log(err)
                })
            },
            openExprot(command) {
                if (command === 'a') {
                    this.dialogFormVisible = true
                }
                if (command === 'b') {
                    this.dialogFormVisible2 = true
                }
            },
            onchange(file, fileList) {
                console.log(file)
                if (fileList.length > 1) {
                    fileList.splice(0, 1);
                }
            },
            localExprot(file) {
                console.log(file)
                if (file) {
                    const param = new FormData()
                    param.append('file', file.file)
                    console.log(param)
                    this.localExprotFile = param
                }
            },
            submitLocalExprot() {
                if (this.localExprotFile) {
                    this.$notify.success({
                        title: '成功提示',
                        message: '本地导入成功'
                    })
                    setTimeout(() => {
                        this.dialogFormVisible = false
                    }, 1000)
                } else {
                    this.$notify.error({
                        title: '错误提示',
                        message: '请先上传文件'
                    })
                }

            },
            handleRemove(file, fileList) {
                console.log(file, fileList);
            },
            echartsChange(e) {
                console.log(e)
                if (e === 0) {
                    this.maxCheck = 1
                } else {
                    this.maxCheck = 5
                }
                this.checkbox = []
                this.option.series = []
                this.option.legend.data = []
                this.option.xAxis = {}
                this.checkbox2 = []
                this.option2.series = []
                this.option2.legend.data = []
                this.option2.xAxis = {}
                // this.loading = true
                // if (this.echartsinstance) {
                //     this.echartsinstance.dispose();
                // }
                // if (this.echartsinstance2) {
                //     this.echartsinstance2.dispose();
                // }
                // // this.isShow = false
                this.echarts = (e * 1 + 1)
                // console.log(this.echarts)
                window.addEventListener("resize", () => {
                    if (this.echartsinstance) {
                        this.echartsinstance.resize();
                    }
                });
                if (this.echarts === 1) {
                    if (this.echartsinstance) {
                        this.echartsinstance.dispose()
                    }
                    if (this.echartsinstance2) {
                        this.echartsinstance2.dispose()
                    }
                    let option = {
                        title: {
                            text: `图1`,
                            left: 'left'
                        },
                        backgroundColor: '#FFF',
                        grid: {
                            top: '9%',
                            bottom: '19%',
                            left: '6%',
                            right: '4%'
                        },
                        tooltip: {
                            trigger: 'axis',
                            label: {
                                show: true
                            }
                        },
                        legend: {
                            right: 20,
                            orient: 'horizontal',
                            data: []
                        },
                        dataZoom: [{
                            type: 'inside',
                            start: 0,
                            end: 2
                        }, {
                            start: 0,
                            end: 10,
                            handleIcon: 'M10.7,11.9v-1.3H9.3v1.3c-4.9,0.3-8.8,4.4-8.8,9.4c0,5,3.9,9.1,8.8,9.4v1.3h1.3v-1.3c4.9-0.3,8.8-4.4,8.8-9.4C19.5,16.3,15.6,12.2,10.7,11.9z M13.3,24.4H6.7V23h6.6V24.4z M13.3,19.6H6.7v-1.4h6.6V19.6z',
                            handleSize: '80%',
                            handleStyle: {
                                color: '#fff',
                                shadowBlur: 3,
                                shadowColor: 'rgba(0, 0, 0, 0.6)',
                                shadowOffsetX: 2,
                                shadowOffsetY: 2
                            }
                        }],
                        xAxis: {},
                        yAxis: {},
                        series: [
                            {
                                name: '',
                                data: [],
                                type: 'line'
                            },
                        ]
                    }
                    let option2 = {
                        title: {
                            text: `图2`,
                            left: 'left'
                        },
                        backgroundColor: '#FFF',
                        grid: {
                            top: '9%',
                            bottom: '19%',
                            left: '6%',
                            right: '4%'
                        },
                        tooltip: {
                            trigger: 'axis',
                            label: {
                                show: true
                            }
                        },
                        legend: {
                            right: 20,
                            orient: 'horizontal',
                            data: []
                        },
                        dataZoom: [{
                            type: 'inside',
                            start: 0,
                            end: 2
                        }, {
                            start: 0,
                            end: 10,
                            handleIcon: 'M10.7,11.9v-1.3H9.3v1.3c-4.9,0.3-8.8,4.4-8.8,9.4c0,5,3.9,9.1,8.8,9.4v1.3h1.3v-1.3c4.9-0.3,8.8-4.4,8.8-9.4C19.5,16.3,15.6,12.2,10.7,11.9z M13.3,24.4H6.7V23h6.6V24.4z M13.3,19.6H6.7v-1.4h6.6V19.6z',
                            handleSize: '80%',
                            handleStyle: {
                                color: '#fff',
                                shadowBlur: 3,
                                shadowColor: 'rgba(0, 0, 0, 0.6)',
                                shadowOffsetX: 2,
                                shadowOffsetY: 2
                            }
                        }],
                        xAxis: {},
                        yAxis: {},
                        series: [
                            {
                                name: '',
                                data: [],
                                type: 'line'
                            },
                        ]
                    }
                    this.$nextTick(() => {
                        let a = document.getElementById('myEcharts1')
                        this.echartsinstance = ec.init(a)
                        this.echartsinstance.setOption(option);
                        let b = document.getElementById('myEcharts2')
                        this.echartsinstance = ec.init(b)
                        this.echartsinstance.setOption(option2);
                    })
                    setTimeout(() => {
                        this.loading = false
                    }, 1000)

                } else {
                    if (this.echartsinstance) {
                        this.echartsinstance.dispose()
                    }
                    if (this.echartsinstance2) {
                        this.echartsinstance2.dispose()
                    }
                    // this.echartsinstance.dispose()
                    // this.echartsinstance2.dispose()
                    let option = {
                        title: {
                            text: `图1`,
                            left: 'left'
                        },
                        backgroundColor: '#FFF',
                        grid: {
                            top: '9%',
                            bottom: '19%',
                            left: '6%',
                            right: '4%'
                        },
                        tooltip: {
                            trigger: 'axis',
                            label: {
                                show: true
                            }
                        },
                        legend: {
                            right: 20,
                            orient: 'horizontal',
                            data: []
                        },
                        dataZoom: [{
                            type: 'inside',
                            start: 0,
                            end: 2
                        }, {
                            start: 0,
                            end: 10,
                            handleIcon: 'M10.7,11.9v-1.3H9.3v1.3c-4.9,0.3-8.8,4.4-8.8,9.4c0,5,3.9,9.1,8.8,9.4v1.3h1.3v-1.3c4.9-0.3,8.8-4.4,8.8-9.4C19.5,16.3,15.6,12.2,10.7,11.9z M13.3,24.4H6.7V23h6.6V24.4z M13.3,19.6H6.7v-1.4h6.6V19.6z',
                            handleSize: '80%',
                            handleStyle: {
                                color: '#fff',
                                shadowBlur: 3,
                                shadowColor: 'rgba(0, 0, 0, 0.6)',
                                shadowOffsetX: 2,
                                shadowOffsetY: 2
                            }
                        }],
                        xAxis: {},
                        yAxis: {},
                        series: [
                            {
                                name: '',
                                data: [],
                                type: 'line'
                            },
                        ]
                    }
                    let option2 = {
                        title: {
                            text: `图2`,
                            left: 'left'
                        },
                        backgroundColor: '#FFF',
                        grid: {
                            top: '9%',
                            bottom: '19%',
                            left: '6%',
                            right: '4%'
                        },
                        tooltip: {
                            trigger: 'axis',
                            label: {
                                show: true
                            }
                        },
                        legend: {
                            right: 20,
                            orient: 'horizontal',
                            data: []
                        },
                        dataZoom: [{
                            type: 'inside',
                            start: 0,
                            end: 2
                        }, {
                            start: 0,
                            end: 10,
                            handleIcon: 'M10.7,11.9v-1.3H9.3v1.3c-4.9,0.3-8.8,4.4-8.8,9.4c0,5,3.9,9.1,8.8,9.4v1.3h1.3v-1.3c4.9-0.3,8.8-4.4,8.8-9.4C19.5,16.3,15.6,12.2,10.7,11.9z M13.3,24.4H6.7V23h6.6V24.4z M13.3,19.6H6.7v-1.4h6.6V19.6z',
                            handleSize: '80%',
                            handleStyle: {
                                color: '#fff',
                                shadowBlur: 3,
                                shadowColor: 'rgba(0, 0, 0, 0.6)',
                                shadowOffsetX: 2,
                                shadowOffsetY: 2
                            }
                        }],
                        xAxis: {},
                        yAxis: {},
                        series: [
                            {
                                name: '',
                                data: [],
                                type: 'line'
                            },
                        ]
                    }
                    this.$nextTick(() => {
                        let a = document.getElementById('myEcharts1')
                        this.echartsinstance = ec.init(a)
                        this.echartsinstance.setOption(option);
                        let b = document.getElementById('myEcharts2')
                        this.echartsinstance2 = ec.init(b)
                        this.echartsinstance2.setOption(option2);
                        setTimeout(() => {
                            this.loading = false
                        }, 1000)
                    })
                }

            },
            // handleCheckChange(data,arrs) {
            //     let itemKey = arrs.halfCheckedNodes[0].key
            //     let son = arrs.checkedNodes[0]
            //     let findKey = itemKey + '||' + son.key
            //     console.log(findKey)
            //     for (let canMapKey in this.convertAscMap) {
            //         // console.log(canMapKey)
            //         if (findKey === canMapKey) {
            //             console.log('找到了')
            //             console.log(this.convertAscMap[canMapKey])
            //             son.val = this.convertAscMap[canMapKey]
            //         }
            //     }
            //     if (!this.isCanMAP) {
            //         this.$notify.error({
            //             title: '错误提示',
            //             message: '请导入报文解析后在勾选'
            //         })
            //         this.loading = false
            //         return false
            //     }
            //     console.log(this.option)
            //     let colorArr = this.colorArr;
            //     console.log(son.val)
            //     this.option.series.push(
            //         {
            //             name: findKey,
            //             type: 'line',
            //             sampling: 'average',//降采样策略
            //             symbol: 'circle',
            //             symbolSize: 7,
            //             lineStyle: {
            //                 color: colorArr[1],
            //                 // shadowBlur: 12,
            //                 // shadowColor: colorArr[i],
            //                 // shadowOffsetX: 1,
            //                 // shadowOffsetY: 1
            //             },
            //             itemStyle: {
            //                 color: colorArr[1],
            //                 borderWidth: 1,
            //                 borderColor: '#FFF'
            //             },
            //             label: {
            //                 show: false,
            //                 distance: 1,
            //             },
            //             data: son.val
            //         },
            //     )
            //     // this.option.series = Array.from(new Set(this.option.series))
            //     this.option.legend.data.push(findKey)
            //     this.option.legend.data = Array.from(new Set(this.option.legend.data))
            //     // 重新渲染
            //     if (this.echarts === 1) {
            //         if (this.echartsinstance) {
            //             this.echartsinstance.dispose()
            //         }
            //         this.option.title = {
            //             text: `图1`,
            //             left: 'left'
            //         }
            //         let a = document.getElementById('myEcharts1')
            //         this.echartsinstance = ec.init(a)
            //         this.echartsinstance.setOption(this.option);
            //     } else {
            //         console.log(this.option)
            //         if (this.echartsinstance) {
            //             this.echartsinstance.dispose()
            //         }
            //         this.option.title = {
            //             text: `图1`,
            //             left: 'left'
            //         }
            //         let a = document.getElementById('myEcharts1')
            //         this.echartsinstance = ec.init(a)
            //         this.echartsinstance.setOption(this.option);
            //     }
            //     setTimeout(() => {
            //         this.loading = false
            //     }, 1000)
            // },
            change(e, itemKey, son, i) {
                // console.log(e, itemKey, son.key)
                let findKey = itemKey + '||' + son.key
                // console.log(findKey)
                for (let canMapKey in this.convertAscMap) {
                    // console.log(canMapKey)
                    if (findKey === canMapKey) {
                        console.log('找到了')
                        console.log(this.convertAscMap[canMapKey])
                        son.val = this.convertAscMap[canMapKey]
                    }
                }
                if (this.echarts === 1) {
                    console.log(this.checkbox)
                    if (this.checkbox.length >= 2) {
                        this.$notify.error({
                            title: '错误提示',
                            message: '单图模式下只能选择一个图例'
                        })
                        this.maxCheck = 1
                        return false
                    }
                } else {
                    this.maxCheck = 5
                    if (this.checkbox.length >= 6) {
                        this.$notify.error({
                            title: '错误提示',
                            message: '单图模式下只能选择一个图例'
                        })
                        this.maxCheck = 5
                        return false
                    }
                }
                this.loading = true
                if (e) {
                    if (!this.isCanMAP) {
                        this.$notify.error({
                            title: '错误提示',
                            message: '请导入报文解析后在勾选'
                        })
                        this.loading = false
                        return false
                    }
                    console.log(this.option)
                    let colorArr = this.colorArr;
                    console.log(son.val)
                    this.option.series.push(
                        {
                            name: findKey,
                            type: 'line',
                            sampling: 'average',//降采样策略
                            symbol: 'circle',
                            symbolSize: 7,
                            lineStyle: {
                                color: colorArr[i],
                                // shadowBlur: 12,
                                // shadowColor: colorArr[i],
                                // shadowOffsetX: 1,
                                // shadowOffsetY: 1
                            },
                            itemStyle: {
                                color: colorArr[i],
                                borderWidth: 1,
                                borderColor: '#FFF'
                            },
                            label: {
                                show: false,
                                distance: 1,
                            },
                            data: son.val
                        },
                    )
                    // this.option.series = Array.from(new Set(this.option.series))
                    this.option.legend.data.push(findKey)
                    this.option.legend.data = Array.from(new Set(this.option.legend.data))
                    // 重新渲染
                    if (this.echarts === 1) {
                        if (this.echartsinstance) {
                            this.echartsinstance.dispose()
                        }
                        this.option.title = {
                            text: `图1`,
                            left: 'left'
                        }
                        let a = document.getElementById('myEcharts1')
                        this.echartsinstance = ec.init(a)
                        this.echartsinstance.setOption(this.option);
                    } else {
                        console.log(this.option)
                        if (this.echartsinstance) {
                            this.echartsinstance.dispose()
                        }
                        this.option.title = {
                            text: `图1`,
                            left: 'left'
                        }
                        let a = document.getElementById('myEcharts1')
                        this.echartsinstance = ec.init(a)
                        this.echartsinstance.setOption(this.option);
                    }
                    setTimeout(() => {
                        this.loading = false
                    }, 1000)
                } else {
                    //  删除，取消选中
                    // this.echartsinstance.dispose();
                    console.log(this.option.xAxis)
                    if (this.option.xAxis.length === 1) {
                        this.option.series.forEach((v, i) => {
                            console.log(v.name)
                            if (findKey === v.name) {
                                this.option.series.splice(i, 1)
                                // this.option.xAxis.splice(i, 1)
                                this.option.legend.data.splice(i, 1)
                                this.echartsinstance.dispose();
                            }
                        })
                    } else {
                        this.option.series.forEach((v, i) => {
                            console.log(v.name)
                            if (findKey === v.name) {
                                this.option.series.splice(i, 1)
                                // this.option.xAxis.splice(i, 1)
                                this.option.legend.data.splice(i, 1)
                            }
                        })
                        setTimeout(this.echartsinstance.setOption(this.option, true), 500);
                    }
                    setTimeout(() => {
                        this.loading = false
                    }, 1000)
                }
            },
            change2(e, itemKey, son, i) {
                console.log(e, itemKey, son.key)
                let findKey = itemKey + '||' + son.key
                // console.log(findKey)
                for (let canMapKey in this.convertAscMap) {
                    // console.log(canMapKey)
                    if (findKey === canMapKey) {
                        console.log('找到了')
                        console.log(this.convertAscMap[canMapKey])
                        son.val = this.convertAscMap[canMapKey]
                    }
                }
                // this.maxCheck = 5
                if (this.echarts === 1) {
                    console.log(this.checkbox)
                    if (this.checkbox.length >= 2) {
                        this.$notify.error({
                            title: '错误提示',
                            message: '单图模式下只能选择一个图例'
                        })
                        this.maxCheck = 1
                        return false
                    }
                } else {
                    this.maxCheck = 5
                    if (this.checkbox.length >= 6) {
                        this.$notify.error({
                            title: '错误提示',
                            message: '单图模式下只能选择一个图例'
                        })
                        this.maxCheck = 5
                        return false
                    }
                }
                // console.log(item)
                this.loading = true
                if (e) {
                    if (!this.isCanMAP) {
                        this.$notify.error({
                            title: '错误提示',
                            message: '请导入报文解析后在勾选'
                        })
                        this.loading = false
                        return false
                    }
                    console.log(this.option2)
                    let colorArr = this.colorArr;
                    // let colorArr = [];
                    // for (let i = 0; i < this.signal2.length; i++) {
                    //     colorArr.push(this.getRandomColor())
                    // }
                    // this.option.xAxis.data = item.val.xList
                    // console.log(this.option2.xAxis)
                    // if (this.option2.xAxis.length === 0) {
                    //     this.option2.xAxis.push(
                    //         {
                    //             boundaryGap: true, //默认，坐标轴留白策略
                    //             axisLine: {
                    //                 show: false
                    //             },
                    //             splitLine: {
                    //                 show: false
                    //             },
                    //             axisTick: {
                    //                 show: false,
                    //                 alignWithLabel: true
                    //             },
                    //             data: item.val.xList,
                    //             axisLabel: {
                    //                 show: true,
                    //                 textStyle: {
                    //                     color: colorArr[i]
                    //                 }
                    //             }
                    //         },
                    //     )
                    // } else {
                    //     this.option2.xAxis.push(
                    //         {
                    //             boundaryGap: true, //默认，坐标轴留白策略
                    //             axisLine: {
                    //                 show: false
                    //             },
                    //             splitLine: {
                    //                 show: false
                    //             },
                    //             axisTick: {
                    //                 show: false,
                    //                 alignWithLabel: true
                    //             },
                    //             data: item.val.xList,
                    //             axisLabel: {
                    //                 show: true,
                    //                 textStyle: {
                    //                     color: colorArr[i]
                    //                 }
                    //             },
                    //             position: 'bottom',// 很重要，如果没有这个设置，默认第二个x轴就会在图表的顶部
                    //             offset: this.option2.xAxis.length * 15,// X 轴相对于默认位置的偏移，在相同的 position 上有多个 X 轴的时候有用
                    //         },
                    //     )
                    // }
                    this.option2.series.push(
                        {
                            name: findKey,
                            type: 'line',
                            sampling: 'average',//降采样策略
                            symbol: 'circle',
                            symbolSize: 7,
                            lineStyle: {
                                color: colorArr[i],
                                // shadowBlur: 12,
                                // shadowColor: colorArr[i],
                                // shadowOffsetX: 1,
                                // shadowOffsetY: 1
                            },
                            itemStyle: {
                                color: colorArr[i],
                                borderWidth: 1,
                                borderColor: '#FFF'
                            },
                            label: {
                                show: false,
                                distance: 1,
                            },
                            data: son.val
                        },
                    )
                    // this.option2.series = Array.from(new Set(this.option2.series))
                    this.option2.legend.data.push(findKey)
                    this.option2.legend.data = Array.from(new Set(this.option2.legend.data))
                    // 重新渲染
                    if (this.echarts === 1) {
                        this.option2.title = {
                            text: `图2`,
                            left: 'left'
                        }
                        let b = document.getElementById('myEcharts2')
                        this.echartsinstance2 = ec.init(b)
                        this.echartsinstance2.setOption(this.option2);
                    } else {
                        this.option2.title = {
                            text: `图2`,
                            left: 'left'
                        }
                        let b = document.getElementById('myEcharts2')
                        this.echartsinstance2 = ec.init(b)
                        this.echartsinstance2.setOption(this.option2);
                        // this.echartsinstance2.clear();
                        // setTimeout(this.echartsinstance2.setOption(this.option2, true), 500);
                    }
                    setTimeout(() => {
                        this.loading = false
                    }, 1000)
                } else {
                    //  删除，取消选中
                    // this.echartsinstance.dispose();
                    if (this.option2.xAxis.length === 1) {
                        this.option2.series.forEach((v, i) => {
                            console.log(v.name)
                            if (findKey === v.name) {
                                this.option2.series.splice(i, 1)
                                // this.option2.xAxis.splice(i, 1)
                                this.option2.legend.data.splice(i, 1)
                                this.echartsinstance2.dispose();
                            }
                        })
                    } else {
                        this.option2.series.forEach((v, i) => {
                            console.log(v.name)
                            if (findKey === v.name) {
                                this.option2.series.splice(i, 1)
                                // this.option2.xAxis.splice(i, 1)
                                this.option2.legend.data.splice(i, 1)
                            }
                        })
                        setTimeout(this.echartsinstance2.setOption(this.option2, true), 500);
                    }
                    setTimeout(() => {
                        this.loading = false
                    }, 1000)
                }
            },
            screen(val) {
                if (val === 1) {
                    this.isScreen = true
                    ScreenFull.toggle(this.$refs.paddingBox1); // 全屏切换
                } else if (val === 2) {
                    ScreenFull.toggle(this.$refs.paddingBox2); // 全屏切换
                }
            },
            getOperatelogList() {
                const data = {
                    pageNo: this.currentPage,
                    pageSize: 20,
                }
                getOperatelogList(data).then(res => {
                    this.activities = res.data
                }).catch(err => {
                    console.log(err)
                })
            },
            getIndex(index) {
                return (this.currentPage - 1) * this.pageSize + index + 1
            },
            getLoadDbcData(data) {
                console.log('父组件', data)
                convertDbc(data).then(res => {
                    console.log(res)
                    // console.log(this.treeData)
                    if (res.code === 200) {
                        if (res.data === null) {
                            console.log('meiyou')
                            this.treeData = []
                            this.treeData2 = JSON.parse(JSON.stringify(this.treeData));
                        }
                        let obj = res.data; //定义对象（data为获取到的对象，在这里定义）
                        console.log(obj)
                        for (let key in obj) {
                            // console.log(Object.values(obj[key]))
                            Object.values(obj[key]).map(v => {
                                v.key = v.signalName
                            })
                            let obj2 = {
                                key,
                                disabled: true,
                                children: Object.values(obj[key])
                            }
                            this.treeData.push(obj2)

                        }
                        console.log('11111111111', this.treeData)
                        this.treeData = this.treeData.sort((a, b) => {
                            return a.key[0].charCodeAt() - b.key[0].charCodeAt()
                            // console.log(a.key[0],b.key[0])
                        })
                        this.treeData2 = JSON.parse(JSON.stringify(this.treeData));
                        if (this.treeData.length > 0) {
                            this.dialogTableVisible = false
                            this.$notify.success({
                                title: '成功提示',
                                message: 'DBC加载成功'
                            })

                        } else {
                            this.dialogTableVisible = false
                            this.$notify.error({
                                title: '错误提示',
                                message: '该DBC暂无数据'
                            })
                        }

                    }
                }).catch(err => {
                    console.log(err)
                })
            },
            // 加载BDC
            loadingDbcDialog() {
                const data = {
                    pageSize: this.pageSize,
                    pageNo: this.currentPage,
                }
                getDbcList(data).then(res => {
                    this.gridData = res.data
                }).catch(err => {
                    console.log(err)
                })
                this.dialogTableVisible = true
            }
        }
    }
</script>

<style scoped lang="scss">
    .journal-box {
        display: flex;
        justify-content: space-between;
        margin-bottom: 20px;
    }

    ::v-deep .el-timeline-item__timestamp.is-bottom {
        position: absolute;
        left: -130px;
        top: -4px;
    }

    .padding-box {
        background: #ffffff !important;
        text-align: left;
        /*padding: 0 20px;*/
    }

    .row-col-style {
        height: 100% !important;
    }

    .left-top-box {
        height: 100%;
    }

    .left-bottom-box {
        margin-top: 20px;
        height: calc(45% - 20px);
    }

    .left-card-top {
        border-radius: 10px;
        height: 100%;

        .cardTop {
            width: 100%;
            margin-bottom: 16px;
            display: flex;
            justify-content: space-between;
        }

        .cardBottom {
            width: 100%;

            .cardTitle {
                display: flex;
                justify-content: space-between;
                align-items: center;
                width: 96%;
                border: 1px solid #cccccc;
                border-radius: 6px;
                font-size: 14px;
                font-weight: bold;
                padding: 8px 10px;
                background: #fafafa;
            }
        }

        .inputClass {
            width: 160px;
        }
    }

    .left-card-bottom {
        border-radius: 10px;
        height: 100%;
    }

    .featerBox {
        height: 100%;
        float: right;
        /*background: #ffffff;*/
        border-radius: 10px;
    }

    .elcol18 {
        height: 100%;
        background: #ffffff;
        border-radius: 10px;
        padding: 20px 0;
        box-sizing: border-box;
    }

    .signal {
        width: 100%;
        padding: 0 10px;
        box-sizing: border-box;
        display: flex;
        justify-content: space-between;
        margin-bottom: 10px;

        span {
            color: #909399;
        }
    }

    .util {
        width: 40%;
        height: 100%;
    }

    .el-icon-video-play, .el-icon-video-pause, .el-icon-refresh {
        font-size: 30px;
        color: #1890ff;
        margin-right: 10px;
        cursor: pointer;
    }

    .myDbcDialog .content-box {
        margin: 0;
        position: relative;
    }

    .el-icon-full-screen {
        cursor: pointer;
    }

    ::v-deep .el-scrollbar__view {
        /*display: flex;*/
    }

    ::v-deep .select-popper {
        /*left: 0 !important;*/
        .el-select-dropdown__item {
            text-align: left;
        }
    }

    ::v-deep .el-tabs__content {
        height: 89% !important;
    }

    /*.myEcharts2{*/
    /*    width: 100%;*/
    /*    height: 100%;*/
    /*    div{*/
    /*        width: 500px !important;*/
    /*        height: 500px !important;*/
    /*    }*/
    /*}*/
    ::v-deep .el-tree {
        padding-top: 15px;
        padding-left: 10px;
        // 不可全选样式
        .el-tree-node {
            .is-leaf + .el-checkbox .el-checkbox__inner {
                display: inline-block;
            }

            .el-checkbox .el-checkbox__inner {
                display: none;
            }
        }
    }

    .el-collapse {
        border: none !important;
    }

    ::v-deep .el-tabs__item {
        font-size: 18px;
        font-weight: bold;
    }
    .active{
        overflow-y: scroll;
    }
</style>
